<mat-spinner *ngIf="showSpinner; else notSpinner"></mat-spinner>
<ng-template #notSpinner>
    <div class="mat-elevation-z4">
        <table mat-table [dataSource]="users">
            <!-- Id Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>Id</th>
                <td mat-cell *matCellDef="let row">{{row.id}}</td>
            </ng-container>

            <!-- Nome Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>nome</th>
                <td mat-cell *matCellDef="let row">{{row.name}}</td>
            </ng-container>

            <!-- E-mail Column -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>E-mail</th>
                <td mat-cell *matCellDef="let row">{{ row.email }}</td>
            </ng-container>

            <!-- Action Column -->
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let row">
                    <div *ngIf="user_id==row.id">
                        <a routerLink="/users/update/{{ row.id }}" class="edit">
                            <i class="material-icons">
                                edit
                            </i>
                        </a>
                        <a routerLink="/users/delete/{{ row.id }}" class="delete">
                            <i class="material-icons">
                                delete
                            </i>
                        </a>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <div *ngIf="users?.length == 0">
        <mat-card>
            Ainda não há usuários cadastrados!
        </mat-card>
    </div>
</ng-template>